module.exports = __webpack_public_path__ + "img/grid-3.ad9891a7.jpg";